import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDictionary, useClient } from "@adamlip/okeoke.client";
import NotAvailableModule from "components/NotAvailableModule";
import SubmittedOrderItemAccordion from "components/Accordions/SubmittedOrderItemAccordion";
import SubmittedOrderInvoiceAccordion from "components/Accordions/SubmittedOrderInvoiceAccordion";
import SubmittedOrderPaymentsAccordion from "components/Accordions/SubmittedOrderPaymentsAccordion";
import moment from "moment";
import { NumericFormat } from "react-number-format";

function OrderDetails() {
  const { id } = useParams();

  const { getValue } = useDictionary();
  const { socketAuthenticated, client, locations } = useClient();
  const [order, setOrder] = useState(null);
  const [totalPayments, setTotalPayments] = useState(null);
  const location = locations?.[order?.locationUUID];

  useEffect(() => {
    if (id != null && socketAuthenticated) {
      client.getUserOrder(id).then((res) => {
        console.log(res);
        if (res.success) {
          setOrder(res.data);
          let total = getTotalPayment(res.data.payments);
          setTotalPayments(total);
        }
      });
    }
    // eslint-disable-next-line
  }, [id, socketAuthenticated]);

  const getTotalPayment = (payments) => {
    if (payments == null) return null;

    let sum = 0;

    for (let payment of payments) {
      sum += payment.amount;
    }
    return sum;
  };

  if (id == null) return <NotAvailableModule />;

  if (order == null) return null;

  return (
    <>
      <div className="order-details-orderNumber font-extraLarge">{`${getValue(
        "app_v2_order"
      )} #${order.orderNumber}`}</div>
      <div className="order-details-header">
        <div className="order-details-title font-large">
          {getValue("app_v2_orderDetails_title")}
        </div>
        <div className="order-details-data-root">
          <div className="order-details-block">
            <div className="order-details-label">
              {getValue("app_v2_orderDetails_location")}:
            </div>
            <div className="order-details-data">{location?.name}</div>
          </div>
          <div className="order-details-block">
            <div className="order-details-label">
              {getValue("app_v2_orderDetails_takeAwayLabel")}
            </div>
            <div className="order-details-data">
              {order.takeAway
                ? getValue("app_v2_orderDetails_takeAway_yes")
                : getValue("app_v2_orderDetails_takeAway_no")}
            </div>
          </div>
          <div className="order-details-block">
            <div className="order-details-label">
              {getValue("app_v2_orderDetails_timestamp")}
            </div>
            <div className="order-details-data">
              {moment(order.insertTimestamp).format("YYYY-MM-DD HH:mm")}
            </div>
          </div>
          {
            <div className="order-details-block">
              <div className="order-details-label">
                {getValue("app_v2_orderDetails_readyTime")}:
              </div>
              <div className="order-details-data">
                {order.requestedReadyTime != null
                  ? order.requestedReadyTime
                  : "lehető leghamarabb"}
              </div>
            </div>
          }
          <div className="order-notes font-smallest">
            {order.notes != null
              ? order.notes
              : getValue("app_v2_orderDetails_notes")}
          </div>
        </div>
      </div>
      <div className="order-details-body">
        <SubmittedOrderItemAccordion
          order={order}
          className="submitted-order-details-accordion"
        />
        <SubmittedOrderInvoiceAccordion
          order={order}
          className="submitted-order-details-accordion"
        />
        <SubmittedOrderPaymentsAccordion
          order={order}
          className="submitted-order-details-accordion"
        />
      </div>
      <div className="order-details-footer">
        <div className="order-details-title font-large">
          {getValue("app_v2_orderDetails_payTitle")}
        </div>
        <div className="submitted-order-details-blocks-root">
          <div className="submitted-order-block">
            <div className="submitted-order-block-label">
              {getValue("app_v2_orderPayments_basketPrice")}:
            </div>
            <div className="submitted-order-block-data">
              <NumericFormat
                value={+order.discountPrice}
                decimalSeparator=","
                suffix=" Ft"
                thousandSeparator="."
                displayType="text"
              />
            </div>
          </div>
          {order.serviceFee?.type === 1 && order.serviceFee?.total > 0 && (
            <div className="submitted-order-block">
              <div className="submitted-order-block-label">
                {getValue("app_v2_orderPayments_serviceFee")}:
              </div>
              <div className="submitted-order-block-data">
                {`${order.serviceFee.total} Ft`}
              </div>
            </div>
          )}
          <div className="submitted-order-block">
            <div className="submitted-order-block-label">
              {getValue("app_v2_orderPayments_totalPrice")}:
            </div>
            <div className="submitted-order-block-data">
              <NumericFormat
                value={+totalPayments}
                decimalSeparator=","
                suffix=" Ft"
                thousandSeparator="."
                displayType="text"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrderDetails;
